const config = {
    // BASE_URL: process.env.VUE_APP_API_URL || "http://goldenkey/api",
    BASE_URL: process.env.VUE_APP_API_URL || "https://api.goldenkey.marrar.co.mz/api",
}

export default config;